import { Icon, Modal, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import * as S from './style';

function ChangePasswordEmailSentModal({ isOpen, onRequestClose, email }) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      primaryButtonProps={{ onClick: onRequestClose }}
      title={t('changePassword')}
      size="sm"
    >
      <S.ModalBody>
        <Icon name="success" size="xxl" color="var(--color-success-default)" />
        <Typography variant="body1Bold" emphasis="bold">
          {t('emailSent')}
        </Typography>
        <Typography variant="body2">
          <Trans
            i18nKey="emailSentChangePassword"
            components={{
              b: <strong />
            }}
            values={{ email }}
          />
        </Typography>
      </S.ModalBody>
    </Modal>
  );
}

ChangePasswordEmailSentModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  email: PropTypes.string
};

export { ChangePasswordEmailSentModal };
